import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// ============================================================
// CHUNK LOAD ERROR HANDLER
// After a new deployment, old JS chunk hashes no longer exist.
// The server returns index.html (text/html) instead of the .js file,
// causing "Failed to load module script" MIME errors → black screen.
// Solution: detect these errors and reload the page once automatically.
// ============================================================

function shouldReloadForChunkError() {
    const lastReload = sessionStorage.getItem('last_chunk_error_reload');
    const now = Date.now();
    // Only reload if we haven't reloaded in the last 10 seconds (avoid infinite loops)
    if (!lastReload || now - parseInt(lastReload) > 10000) {
        sessionStorage.setItem('last_chunk_error_reload', now.toString());
        return true;
    }
    return false;
}

// 1) Catch unhandled promise rejections (dynamic import() failures land here)
window.addEventListener('unhandledrejection', (e) => {
    const msg = e.reason?.message || '';
    if (
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('Importing a module script failed') ||
        msg.includes('error loading dynamically imported module')
    ) {
        e.preventDefault();
        if (shouldReloadForChunkError()) {
            console.warn('[ChunkError] Detected stale chunk → reloading page...');
            window.location.reload();
        }
    }
});

// 2) Catch <script> tag load errors (safety net for module preloads)
window.addEventListener('error', (e) => {
    if (e.target?.tagName === 'SCRIPT' || e.target?.tagName === 'LINK') {
        if (shouldReloadForChunkError()) {
            console.warn('[ChunkError] Script/link failed to load → reloading page...');
            window.location.reload();
        }
    }
}, true);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
